import Base2Repository from "./base2.repository";
import { GenericPersistence } from "core/data/persistence";
import { GenericService } from "core/data/service";

class OptionalSalesReportRepository extends Base2Repository {
  getPersistenceProvider() {
    return new GenericPersistence(this.getEntityIdentifier());
  }

  getServiceProvider() {
    return new GenericService({});
  }

  async getOptionalReport(from, to) {
    const result = await this.get("/v1/optionals_reports", {
      from: from,
      to: to
    });
    return result;
  }
}

export default new OptionalSalesReportRepository();



// WEBPACK FOOTER //
// ./src/core/repository/optional-sales-report.repository.js